module.exports = __webpack_public_path__ + "img/EISEnglish_logo.77f1ba1e.png";